import { render, staticRenderFns } from "./CreatorsSlider.vue?vue&type=template&id=e537050a&scoped=true&"
import script from "./CreatorsSlider.vue?vue&type=script&lang=ts&"
export * from "./CreatorsSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsSlider.vue?vue&type=style&index=0&id=e537050a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e537050a",
  null
  
)

export default component.exports